import { useNavigate } from 'react-router-dom';

/**
 * Navigate to full booking checkout page (not popup).
 * @param {'flight'|'hotel'|'car'|'package'|'cruise'} serviceType
 */
export default function BookNowButton({
  label = 'Select',
  className = 'btn-select',
  serviceType = 'flight',
  bookingPayload,
}) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (!bookingPayload) return;
    navigate(`/flight/book/${serviceType}`, { state: { payload: bookingPayload } });
  };

  return (
    <button type="button" className={className} onClick={handleClick}>
      {label}
    </button>
  );
}
